/**
 * 車輌年式セレクト用オプション（useSelectEx.select_Sharyo_Nenshiki_Nashi と同一）
 */

/**
 * @param {number} year 西暦年
 * @returns {string} 和暦表記
 */
export function convertJapaneseYearForSelect(year) {
  if (year >= 2020) return `R${year - 2018}`;
  if (year >= 1989) return `H${year - 1988}`;
  if (year >= 1927) return `S${year - 1925}`;
  return `${year}年以前`;
}

/**
 * 年式なし付きの年式オプション（現在年〜1993年）
 * @returns {Array<{ key: string; value: string; label: string }>}
 */
export function makeSharyoNenshikiNashiOptions() {
  const options = [];
  let nen = new Date().getFullYear();

  for (;;) {
    const wareki = convertJapaneseYearForSelect(nen);
    let label = `${wareki}(${nen}年)`;
    if (nen === 1993) {
      label += "以前";
    }
    options.push({ key: String(nen), value: String(nen), label });
    nen -= 1;
    if (nen < 1993) {
      break;
    }
  }

  options.push({ key: "年式なし", value: "年式なし", label: "年式なし" });
  return options;
}

/**
 * 親フォームの Sharyo_Nenshiki をダイアログ検索条件用に正規化
 * @param {unknown} value
 */
export function normalizeSharyoNenshikiForCriteria(value) {
  const v = value == null ? "" : String(value).trim();
  if (v === "" || v === "-1") return "";
  return v;
}
